import { render } from "./LicenseDetailSandbox.vue?vue&type=template&id=ac57ed84"
import script from "./LicenseDetailSandbox.vue?vue&type=script&lang=js"
export * from "./LicenseDetailSandbox.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Teh/Dev/web/loop-client-dashboard/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__